import { render, staticRenderFns } from "./DeleteService.vue?vue&type=template&id=6bb17b40&"
import script from "./DeleteService.vue?vue&type=script&lang=js&"
export * from "./DeleteService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports